// assets/cours-filter.js

// ─── Config ───────────────────────────────────────────────────────────────────
const NETLIFY_URL = 'https://astounding-cassata-06e113.netlify.app/.netlify/functions/get-articles';
const CACHE_KEY = 'articles_cache';
const CACHE_TTL = 60 * 60 * 2000; // 2h

const BLOG_HANDLE = 'cours';
const BATCH_SIZE = 24;

// ─── Cache articles ───────────────────────────────────────────────────────────
async function getArticles() {
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
            const { data, cachedAt } = JSON.parse(cached);
            if (Date.now() - cachedAt < CACHE_TTL) {
                console.log('📦 Articles depuis le cache');
                return data;
            }
        }
    } catch (e) {
        console.warn('Cache illisible, on refetch :', e);
    }

    console.log('🔄 Fetch articles depuis Netlify...');
    const res = await fetch(NETLIFY_URL);
    if (!res.ok) throw new Error(`Erreur Netlify : ${res.status}`);

    const data = await res.json();

    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ data, cachedAt: Date.now() }));
    } catch (e) {
        console.warn('localStorage plein :', e);
    }

    return data;
}

// ─── Collecte des filtres actifs ──────────────────────────────────────────────
function collectFilters() {
    const keyByGroupId = {};
    document.querySelectorAll('[data-filter-id][data-filter-key]').forEach(el => {
        const id = el.dataset.filterId;
        const key = el.dataset.filterKey.trim();
        if (id && key) keyByGroupId[id] = key;
    });

    // Agréger les valeurs cochées par clé métier
    const filters = {};
    document.querySelectorAll('input[type="checkbox"][data-filter-group]:checked').forEach(cb => {
        const key = keyByGroupId[cb.dataset.filterGroup];
        if (!key) return;
        if (!filters[key]) filters[key] = [];
        filters[key].push(cb.value);
    });

    // Recherche textuelle : préférer la valeur non-vide des deux inputs
    const search = (
        document.getElementById('filter-search')?.value.trim() ||
        document.getElementById('filter-search-mobile')?.value.trim() ||
        ''
    ).toLowerCase();

    return { filters, search };
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

// Convertit n'importe quelle valeur en tableau de strings brutes.
// Gère : string JSON "[\"a\",\"b\"]", vrais tableaux, tableaux imbriqués, strings simples.
function toStringArray(raw) {
    if (raw === undefined || raw === null) return [];

    // Vrai tableau → aplatir récursivement
    if (Array.isArray(raw)) return raw.flat(Infinity).map(String);

    const str = String(raw).trim();

    // String JSON qui ressemble à un tableau : "[\"...\"]"
    if (str.startsWith('[')) {
        try {
            const parsed = JSON.parse(str);
            if (Array.isArray(parsed)) return parsed.flat(Infinity).map(String);
        } catch (_) { /* pas du JSON valide, on traite comme string */ }
    }

    return [str];
}

// Handleize : lowercase + sans accents + sans caractères spéciaux → comparable de façon fiable.
function handleize(v) {
    return String(v)
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // supprimer accents
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // tout ce qui n'est pas alphanum → tiret
        .replace(/^-+|-+$/g, '');    // trim tirets
}

// ─── Filtrage ─────────────────────────────────────────────────────────────────
// AND entre les groupes, OR à l'intérieur d'un groupe.
function filterArticles(articles, { filters, search }) {
    return articles.filter(article => {
        const matchesFilters = Object.entries(filters).every(([key, values]) => {
            const raw = article[key];

            if (raw === undefined || raw === null || raw === '') {
                // console.warn(`⚠️ Clé "${key}" absente/vide sur "${article.handle}"`, article);
                return false;
            }

            const articleHandles = toStringArray(raw).map(handleize);
            const filterHandles = values.map(handleize);

            const match = filterHandles.some(fh => articleHandles.includes(fh));

            if (!match) {
                // console.log(`🚫 No match — "${key}" | article: [${articleHandles}] | filtre: [${filterHandles}]`);
            }

            return match;
        });

        const matchesSearch = !search ||
            article.title?.toLowerCase().includes(search);

        return matchesFilters && matchesSearch;
    });
}

// ─── Affichage ────────────────────────────────────────────────────────────────
async function renderFilteredArticles(handles) {
    const container = document.getElementById('blog-post-list');
    container.innerHTML = '<div class="loading">Chargement...</div>';

    if (!handles.length) {
        container.innerHTML = '<p class="no-results">Aucun résultat.</p>';
        return;
    }

    // Découper en batches
    const batches = [];
    for (let i = 0; i < handles.length; i += BATCH_SIZE) {
        batches.push(handles.slice(i, i + BATCH_SIZE));
        console.log("Batch: ", batches);
    }

    // Fetch tous les batches en parallèle
    const results = await Promise.all(
        batches.map(batch => {
            const params = new URLSearchParams({ 
                type: batch.join(','),
                q: Date.now() // cache buster
            });
            return fetch(`/blogs/${BLOG_HANDLE}?view=ajax&${params}`)
                .then(res => res.text());
        })
    );

    container.innerHTML = results.join('') || '<p class="no-results">Aucun résultat.</p>';

    // Forcer la visibilité reveal-on-scroll
    // container.querySelectorAll('[reveal-on-scroll]').forEach(el => {
    //     el.setAttribute('reveal-on-scroll', 'false');
    //     el.style.opacity = '1';
    // });

    // Cacher la pagination native
    document.getElementById('pagination').style.display = 'none';
}

// function renderPagination(total) {
//     const totalPages = Math.ceil(total / PER_PAGE);
//     console.log(`Total: ${total} | Pages: ${totalPages}`);
    
//     const pagination = document.getElementById('pagination');
//     pagination.style.display = "none";
//     // Forcer la visibilité sur les éléments injectés
// }

// ─── Exécution d'une recherche ────────────────────────────────────────────────
async function runFilter(btn) {
    btn.disabled = true;
    const originalText = btn.textContent.trim();
    btn.textContent = 'Chargement...';

    try {
        const articles = await getArticles();
        console.log(`✅ ${articles.length} articles récupérés :`, articles);

        const { filters, search } = collectFilters();
        console.log('🎯 Filtres appliqués :', { filters, search });

        const hasFilters = Object.keys(filters).length > 0;
        const hasSearch = search.length > 0;

        if (!hasFilters && !hasSearch) {
            // renderArticles(null); // tout afficher
            console.log('Aucun resultats');
            return;
        }

        const filtered = filterArticles(articles, { filters, search });
        const handles = filtered.map(a => a.handle);
        console.log(`🔍 ${handles.length} articles correspondent :`, handles);

        renderFilteredArticles(handles);

    } catch (e) {
        console.error('❌ Erreur filtre :', e);
    } finally {
        btn.disabled = false;
        btn.textContent = originalText;
    }
}

// ─── Init ─────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
    const btns = document.querySelectorAll('[data-filter-apply]');

    if (!btns.length) {
        console.warn('❌ Aucun bouton [data-filter-apply] trouvé');
        return;
    }

    btns.forEach(btn => {
        btn.addEventListener('click', () => runFilter(btn));
    });

    // Fermer les dropdowns au clic en dehors
    document.addEventListener('click', (e) => {
        document.querySelectorAll('.blog-filter-item[open]').forEach(details => {
            if (!details.contains(e.target)) details.removeAttribute('open');
        });
    });
});
